import type { ReactNode } from 'react';

/**
 * Block 14 «Раскрой» — обёртка модалки `.sc-modal2` (PR #4-SHELL).
 * Разметка/классы вербатим из `project.html` (`.sc-modal2-overlay` → `.sc-modal2`
 * → `-title` / `-content` / `-footer`) + `styles.css` каскад. Рендерится только
 * когда открыта (overlay всегда `visible`).
 */
export function CuttingModal2({
  title,
  children,
  footer,
}: {
  title: string;
  children: ReactNode;
  footer: ReactNode;
}) {
  return (
    <div className="sc-modal2-overlay visible" role="dialog" aria-modal="true" aria-label={title}>
      <div className="sc-modal2">
        <div className="sc-modal2-title">{title}</div>
        <div className="sc-modal2-content">{children}</div>
        <div className="sc-modal2-footer">{footer}</div>
      </div>
    </div>
  );
}
